export default {
  cognito: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_IOlyEpXCj",
    APP_CLIENT_ID: "3ju3n38fu2o0s6dooqt025j8a4",
    IDENTITY_POOL_ID: "us-east-1:ae873200-4e65-4585-bb1b-e3561f00da98"
  }
};
